import { callToastState } from '../../models/callModel';
import { Types } from '../action/action';

const initialState = { isToast: false, message: "" };

export const showError = (state:callToastState  = initialState, action: any) => {
  const { type, payloads } = action;
  switch (type) {
  case Types.SHOW_ERROR:
    return {
      ...state, isToast: payloads.isToast, message:payloads.message
    };
  default:
    return state;
  };
};